import React from 'react';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
import { FinancingHero } from '../components/financing/FinancingHero';
import { FinancingBenefits } from '../components/financing/FinancingBenefits';
import { CherrySection } from '../components/financing/CherrySection';
import { PatientFiSection } from '../components/financing/PatientFiSection';
import { CareCreditSection } from '../components/financing/CareCreditSection';
import { FinancingFAQ } from '../components/financing/FinancingFAQ';
import { FinancingConsultCTA } from '../components/financing/FinancingConsultCTA';
export function FinancingPage() {
  return <div className="min-h-screen w-full bg-black font-body" style={{
    scrollBehavior: 'smooth'
  }} data-id="element-2525">
      <Navigation data-id="element-2526" />
      <main data-id="element-2527">
        <FinancingHero data-id="element-2528" />
        <FinancingBenefits data-id="element-2529" />
        <CherrySection data-id="element-2530" />
        <PatientFiSection data-id="element-2531" />
        <CareCreditSection data-id="element-2532" />
        <FinancingFAQ data-id="element-2533" />
        <FinancingConsultCTA data-id="element-2534" />
      </main>
      <Footer data-id="element-2535" />
    </div>;
}